import { getI18n } from '@bridebook/web/lib/i18n/getI18n';

export const getCostsTranslation: Record<string, () => string> = {
  a4cc6_announcements: () => getI18n().t('countries:costs.a4cc6_announcements'),
  f1d71_insurance: () => getI18n().t('countries:costs.f1d71_insurance'),
  fa341_videographer: () => getI18n().t('countries:costs.fa341_videographer'),
  f33ec_honeymoon: () => getI18n().t('countries:costs.f33ec_honeymoon'),
  '6ec13_menswear': () => getI18n().t('countries:costs.6ec13_menswear'),
  e2992_florist: () => getI18n().t('countries:costs.e2992_florist'),
  b2b07_cateringFoodDrink: () => getI18n().t('countries:costs.b2b07_cateringFoodDrink'),
  cc07b_transport: () => getI18n().t('countries:costs.cc07b_transport'),
  b8da0_weddingNightBridal: () => getI18n().t('countries:costs.b8da0_weddingNightBridal'),
  '6dd11_marquee': () => getI18n().t('countries:costs.6dd11_marquee'),
  '5af4c_beautyHairMakeUp': () => getI18n().t('countries:costs.5af4c_beautyHairMakeUp'),
  c74f2_weddingDressAccessories: () => getI18n().t('countries:costs.c74f2_weddingDressAccessories'),
  '3aa89_plannerToastmasterCelebrant': () =>
    getI18n().t('countries:costs.3aa89_plannerToastmasterCelebrant'),
  bd7d9_decorationHire: () => getI18n().t('countries:costs.bd7d9_decorationHire'),
  '0ea3d_marriageLicenseFees': () => getI18n().t('countries:costs.0ea3d_marriageLicenseFees'),
  '2ac87_stationery': () => getI18n().t('countries:costs.2ac87_stationery'),
  a439a_entertainment: () => getI18n().t('countries:costs.a439a_entertainment'),
  '9594e_favoursGifts': () => getI18n().t('countries:costs.9594e_favoursGifts'),
  '9bbb7_cake': () => getI18n().t('countries:costs.9bbb7_cake'),
  bab4e_extras: () => getI18n().t('countries:costs.bab4e_extras'),
  a35bb_photographer: () => getI18n().t('countries:costs.a35bb_photographer'),
  '3d8f5_venue': () => getI18n().t('countries:costs.3d8f5_venue'),
  '712ec_music': () => getI18n().t('countries:costs.712ec_music'),
  '61079_weddingRingsJewellery': () => getI18n().t('countries:costs.61079_weddingRingsJewellery'),
};
